// src/components/CampsiteMapListView.jsx
import React, { useState } from 'react'
import BannerCarousel from './BannerCarousel'

const PITCHES = [
  {
    id: 1,
    name: 'Safari Tent 1',
    type: 'Safari tents',
    x: 150, y: 120, r: 20,
    available: true,
    options: { view360: '/360/safari-tent-1.jpg', video: 'https://youtu.be/example1' }
  },
  {
    id: 2,
    name: 'Gypsy Caravan',
    type: 'Gypsy caravan',
    x: 280, y: 200, r: 20,
    available: true,
    options: { view360: '/360/gypsy-caravan-1.jpg', video: 'https://youtu.be/example2' }
  },
  {
    id: 3,
    name: 'Yurt 1',
    type: 'Yurt',
    x: 400, y: 300, r: 20,
    available: false,
    options: { view360: '/360/yurt-1.jpg', video: 'https://youtu.be/example3' }
  },
  {
    id: 4,
    name: 'Pitch 1',
    type: 'Tent',
    x: 450, y: 155, r: 15,
    available: true,
    options: {}
  },
  {
    id: 5,
    name: 'Pitch 2',
    type: 'Tent',
    x: 504, y: 134, r: 15,
    available: true,
    options: {}
  },
  {
    id: 6,
    name: 'Pitch 3',
    type: 'Tent',
    x: 473, y: 134, r: 15,
    available: false,
    options: {}
  }
]

const TYPES = ['Safari tents', 'Gypsy caravan', 'Yurt', 'Tent']

export default function CampsiteMapListView() {
  const [view, setView] = useState('map')
  const [selected, setSelected] = useState(null)
  const [filters, setFilters] = useState(
    TYPES.reduce((acc, t) => ({ ...acc, [t]: true }), {})
  )
  const toggleFilter = t => setFilters(f => ({ ...f, [t]: !f[t] }))
  const active = Object.keys(filters).filter(t => filters[t])
  const filtered = PITCHES.filter(
    p => !active.length || active.includes(p.type)
  )

  return (
    <div className="min-h-screen bg-gray-50">
      <BannerCarousel />

      <main className="max-w-7xl mx-auto px-4 py-12 space-y-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex space-x-4">
            <button
              onClick={() => setView('map')}
              className={`px-4 py-2 rounded ${view === 'map' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            >
              Map View
            </button>
            <button
              onClick={() => setView('list')}
              className={`px-4 py-2 rounded ${view === 'list' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            >
              List View
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {TYPES.map(type => (
              <label key={type} className="inline-flex items-center">
                <input
                  type="checkbox"
                  checked={filters[type]}
                  onChange={() => toggleFilter(type)}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
                <span className="ml-1">{type}</span>
              </label>
            ))}
          </div>
        </div>

        {view === 'map' ? (
          <>
            <div className="overflow-hidden border rounded shadow-lg">
              <img
                src="/low-wray-map.jpg"
                alt="Campsite map"
                useMap="#campmap"
                className="w-full h-auto block"
              />

              <map name="campmap">
                {filtered.map(p => (
                  <area
                    key={p.id}
                    shape="circle"
                    coords={`${p.x},${p.y},${p.r}`}
                    href="#!"
                    alt={p.name}
                    onClick={e => {
                      e.preventDefault()
                      setSelected(p)
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                ))}
              </map>
            </div>
          </>
        ) : (
          <div className="space-y-4">
            {filtered.map(p => (
              <div
                key={p.id}
                className="flex justify-between items-center bg-white p-4 rounded shadow-sm"
              >
                <div>
                  <h3 className="text-lg font-semibold">{p.name}</h3>
                  <p className="text-sm text-gray-600">{p.type}</p>
                </div>
                <button
                  onClick={() => setSelected(p)}
                  disabled={!p.available}
                  className={`px-4 py-2 rounded text-sm font-medium ${
                    p.available
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-300 text-gray-700 cursor-not-allowed'
                  }`}
                >
                  {p.available ? 'Book Now' : 'Booked'}
                </button>
              </div>
            ))}
          </div>
        )}

        {selected && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 max-w-sm w-full space-y-4">
              <h2 className="text-2xl font-bold">{selected.name}</h2>
              <p>
                Type: <span className="font-medium">{selected.type}</span>
              </p>
              <p>
                Availability:{' '}
                <span className={selected.available ? 'text-green-600' : 'text-red-600'}>
                  {selected.available ? 'Available' : 'Booked'}
                </span>
              </p>
              {selected.options.view360 && (
                <a
                  href={selected.options.view360}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-blue-600 hover:underline"
                >
                  View 360°
                </a>
              )}
              {selected.options.video && (
                <a
                  href={selected.options.video}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-blue-600 hover:underline"
                >
                  Watch Video
                </a>
              )}
              <button
                onClick={() => alert('Booking email sent!')}
                className="w-full py-2 bg-purple-600 text-white rounded hover:bg-purple-700 transition"
              >
                Email Booking Info
              </button>
              <button
                onClick={() => setSelected(null)}
                className="mt-3 w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  )
}